"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuperApp = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SuperApp = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1536 1536",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "linear-gradient",
      x1: "768",
      y1: "1533.05",
      x2: "768",
      y2: "1.91",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: "0",
        stopColor: "#fd2835"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: "0.42",
        stopColor: "#e49c33"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: "1",
        stopColor: "#d4f90c"
      })]
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledG, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Layer_1",
      "data-name": "Layer 1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledRect, {
        width: "1536",
        height: "1536",
        rx: "768"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledPath, {
        d: "M862.74,411c-292.11,0-312.39,293-312.39,293h9.55s53.45-209.86,253.25-209.86c161.4,0,285.28,112.82,285.28,270.82.77,183.23-147.13,332.38-330.36,333.17-174.34,0-339.08-135-339.08-370.25,0-184,101.07-334.94,266.85-400L693.55,318c-246.63,43.39-411.4,278.5-368,525.14,37.87,215.29,224,372.91,442.53,374.86,249.2-1,450.36-203.9,449.32-453.1,0-241.54-204.64-353.95-354.65-353.95"
      })]
    })
  })]
});
exports.SuperApp = SuperApp;